export default {
  expensesFor: 'Išlaidos už {month} mėnesį',
  clickTooltip: 'Spustelėjus vardą galima sužinoti daugiau informacijos',
  name: 'Vardas',
  days: 'Dienos',
  paidCost: 'Mokėtina Suma',
  actualCost: 'Bendra Suma',
  hasUserPaid: 'Sumokėta',
  hasUserNotPaid: 'Nesumokėta',
  userPaidDialogTitle: 'Prašome patvirtinti',
  userPaidDialogText: 'Ar vartotojas {displayName} sumokėjo {paidCost}€?',
  userPaidDialogUndoText: 'Vartotojas {displayName} pasirinktu laikotarpiu jau yra susimokėjęs. Ar norite tai anuliuoti?',
  userPaidDialogName: 'Vartotojas',
  userPaidDialogAmount: 'Sumokėta suma',
  userPaidDialogDate: 'Laikotarpis',
  allUsersPaid: 'Visi susimokėjo!',
  sendPayReminder: 'Siųsti priminimą',
  total: 'Bendra suma: {total}€',
  totalToCollect: 'Suma, kurią reikia surinkti: {total}€',
  intervalTypeFullMonth: 'Pilnas mėnuo',
  intervalTypeFirstHalf: 'Pirma pusė',
  intervalTypeSecondHalf: 'Antra pusė',
};
